import { render, staticRenderFns } from "./ViewLabel.vue?vue&type=template&id=c5b7a4fc&"
import script from "./ViewLabel.vue?vue&type=script&lang=js&"
export * from "./ViewLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports